import React from "react";
import ReactDOM from "react-dom";
import Lightbox from "react-awesome-lightbox";

function showLightbox(props) {
  const container = document.createElement("div");
  document.body.appendChild(container);

  const unMount = () => {
    ReactDOM.unmountComponentAtNode(container);
    try {
      container.parentElement?.removeChild(container);
    } catch (e) {
      console.warn(e);
    }
  };

  const handleClose = () => {
    unMount();
    return props?.onClose?.();
  };

  ReactDOM.render(<Lightbox {...props} onClose={handleClose} />, container);
}

export default showLightbox;
